import styled from '@emotion/styled'
import { calcRem } from '../../__styling'

export const StyledUserSettingsForm = styled('form')(({ theme }) => [
    // PerthNow Styling
    theme.kind === 'perthnow' && {
        paddingTop: calcRem(16),
    },
])
